import React from 'react';
import style from './Portfolio.module.css';
import ProjectCard from '../../Components/Cards/Project/ProjectCard';
import ProjectList from '../../Data/ProjectList';

const Portfolio = () => {
	return (
		<section className={style.Portfolio} id='portfolio' data-reveal="fade">
			<h2 className='Heading'>
				Selected Projects
			</h2>

			<div className={style.ProjectCardContianer} data-reveal="up">
				{ProjectList.map((project) =>
					<ProjectCard
						ProjectCategory={project.ProjectCategory}
						ProjectName={project.ProjectName}
						ProjectImage={project.ProjectImage}
						ProjectDescription={project.ProjectDescription}
						ProjectTechnologies={project.ProjectTechnologies}
						ProjectLiveLink={project.ProjectLiveLink}
						ProjectDemoLink={project.ProjectDemoLink}
						ProjectRepoLink={project.ProjectRepoLink}
						ProjectColor={project.ProjectColor}
						key={project.ProjectName}
					/>
				)}
			</div>

		</section>

	)
}

export default Portfolio;